import React from 'react';
import { FileText } from 'lucide-react';
export function ProductSpecs() {
  return <div className="mt-12" data-id="element-560" data-mp="28azic5ft12ta">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-561" data-mp="28calq45c88jv">
        {/* Left Column */}
        <div className="space-y-8" data-id="element-562" data-mp="2da3pkqj64qgz">
          <section data-id="element-563" data-mp="2d913qx0pde7x">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4 flex items-center gap-2" data-id="element-564" data-mp="2d8iw748lbdkp">
              <FileText className="w-5 h-5 text-brand-darkGold" data-id="element-565" data-mp="2n0oo6dyuduzw" />
              General Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-566" data-mp="2ry71egjw6wdp">
              <table className="w-full text-sm" data-id="element-567" data-mp="2w0liav403m2c">
                <tbody data-id="element-568" data-mp="2vyqyjk4gtzzu">
                  <tr className="border-b border-gray-100" data-id="element-569" data-mp="30zoaheyvtxsw">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-570" data-mp="30z532s6uyrt4">
                      Brand
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-571" data-mp="16ldm17m795nn">MA Ford</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-572" data-mp="211n9sdjehygl">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-573" data-mp="2136rm8kpghkh">
                      Series
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-574" data-mp="1s922pup4tg7l">MAF177</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-575" data-mp="1naqufoehjdrh">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-576" data-mp="1ncbn18h8ommp">
                      Classification
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-577" data-mp="2fymosmgl0tl3">
                      High Performance
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-578" data-mp="2ay8e0wnlj5jd">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-579" data-mp="261rnjvsxcf34">
                      Tool Material
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-580" data-mp="zitfvpjni7mo">Carbide</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-581" data-mp="ukiabr0e2ja9">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-582" data-mp="w41q9vhi8m8e">
                      Size Category
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-583" data-mp="10zz3vu1dvehh">Metric</td>
                  </tr>
                  <tr data-id="element-584" data-mp="n4eo37gybcea">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-585" data-mp="s1depg1ep17q">
                      Material Families
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-586" data-mp="dbpginoiuio8">
                      Steels etc.(P, K, M, S)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-587" data-mp="49zobfmtffpe">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-588" data-mp="8d4mx73ryx8r">
              Diameter Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-589" data-mp="3qjsq2rf9labs">
              <table className="w-full text-sm" data-id="element-590" data-mp="3vhkgfh09godv">
                <tbody data-id="element-591" data-mp="3bw2ag6p53kgt">
                  <tr className="border-b border-gray-100" data-id="element-592" data-mp="3bxd8dpvwly00">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-593" data-mp="36x8um7mdrhdh">
                      Diameter Information
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-594" data-mp="3lw2r1kvmjmhb">0.7874 20.0mm</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-595" data-mp="3gtu16xe1t0jf">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-596" data-mp="3uuehnmwhqk9r">
                      Diameter Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-597" data-mp="3pu0i6t8yginc">+.000" -.0015"</td>
                  </tr>
                  <tr data-id="element-598" data-mp="8ho9j4e7vnar">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-599" data-mp="3gs8qzp5wh9k">
                      OD Grind
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-600" data-mp="hh32qblrqbyy">Eccentric</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-601" data-mp="26y6zdwmjvt0t">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-602" data-mp="26wm58845ec3h">
              Shank Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-603" data-mp="2gngqb95nr5nc">
              <table className="w-full text-sm" data-id="element-604" data-mp="2lmbiv2tfg8kn">
                <tbody data-id="element-605" data-mp="2ll04ya69pkft">
                  <tr className="border-b border-gray-100" data-id="element-606" data-mp="2llici2ydrl31">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-607" data-mp="1nzkx4efarvvb">
                      Shank Diameter
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-608" data-mp="1szgz684fpd88">20mm</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-609" data-mp="1xytk2nbqwa86">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-610" data-mp="21z3s05j3lapo">
                      Shank Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-611" data-mp="3ddhbyzaqd60f">+.0000" -.0005"</td>
                  </tr>
                  <tr data-id="element-612" data-mp="11q4d2rn0zig4">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-613" data-mp="11qnnzoe9d6kn">
                      Shank Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-614" data-mp="xpc31w6bx9is">Straight</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Right Column */}
        <div className="space-y-8" data-id="element-615" data-mp="nwwlgzyy2myf">
          <section data-id="element-616" data-mp="izwfsq60bm7u">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-617" data-mp="j0fn7cy16s7m">
              Length Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-618" data-mp="9yohw97eknea">
              <table className="w-full text-sm" data-id="element-619" data-mp="4zv38dgdqqcj">
                <tbody data-id="element-620" data-mp="516hx8bd5iif">
                  <tr className="border-b border-gray-100" data-id="element-621" data-mp="51psg3yop4mf">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-622" data-mp="24bxvac32kt1t">
                      Flute Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-623" data-mp="1zc1qwbqgmzlq">38mm</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-624" data-mp="2igep6ozqkjc5">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-625" data-mp="2na9dk5qadmhk">
                      Neck Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-626" data-mp="29fzytb7x0e1s">~~~</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-627" data-mp="2eetglfu8ir7r">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-628" data-mp="327jpthar6wec">
                      Overall Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-629" data-mp="365r507pkjpnf">104mm</td>
                  </tr>
                  <tr data-id="element-630" data-mp="2saf39gczwyx0">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-631" data-mp="2x75enqduv6c3">
                      Length Category
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-632" data-mp="1grko30vtghw9">Standard</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-633" data-mp="1e7obak3zh4mz">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-634" data-mp="1e765avrirc1v">
              Fluting Geometry
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-635" data-mp="1n95n3qacyk5v">
              <table className="w-full text-sm" data-id="element-636" data-mp="1iab5gro4n1nc">
                <tbody data-id="element-637" data-mp="1ibma0tpecdfi">
                  <tr className="border-b border-gray-100" data-id="element-638" data-mp="1i8879kctm27j">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-639" data-mp="ulrxkd8zoqvs">
                      Number of Flutes
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-640" data-mp="14ajlmaaxir1f">4</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-641" data-mp="14ce99wdl4x97">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-642" data-mp="zj1lfogqcuhi">
                      Helix Angle
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-643" data-mp="brw9hkdwumch">35/38°</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-644" data-mp="6tbfw3t5z0x0">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-645" data-mp="3ig1ispsjdxu6">
                      Flute Index
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-646" data-mp="3rfek2v6ibg3t">Variable</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-647" data-mp="3rhra7vmf4wry">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-648" data-mp="9wqy3c6zaw7">
                      Cut
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-649" data-mp="56dkjd25uhgo">
                      Center Cutting Right Hand
                    </td>
                  </tr>
                  <tr data-id="element-650" data-mp="e1tahizsocgz">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-651" data-mp="e1a1wsw1b0fm">
                      Spiral
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-652" data-mp="nz7shn1d99be">Right Hand</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-653" data-mp="sverswz9bmkd">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-654" data-mp="2dgcqy7lme5sg">
              Coating & End Configuration
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-655" data-mp="28itg7ho4sb59">
              <table className="w-full text-sm" data-id="element-656" data-mp="23hvwv1rdxb26">
                <tbody data-id="element-657" data-mp="1yj2gn1kpr5yb">
                  <tr className="border-b border-gray-100" data-id="element-658" data-mp="1yjue6hxvfdr8">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-659" data-mp="2w61hzpmcp22j">
                      Coating
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-660" data-mp="2r7qahljj33nh">AlTiN</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-661" data-mp="2mf6tsfpjnseg">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-662" data-mp="2hhonkx2wvra5">
                      End Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-663" data-mp="3eydis7xcvvak">
                      Single End Corner Radius
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-664" data-mp="2124fvw4ywjc3">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-665" data-mp="212ny7dyj59qn">
                      Corner Radius
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-666" data-mp="2b13ioy31xkr6">3.0mm</td>
                  </tr>
                  <tr data-id="element-667" data-mp="260xwvyjgqsh0">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-668" data-mp="260fqi9336xvd">
                      Corner Chamfer
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-669" data-mp="2jyvys4glkwfm">~~~</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>;
}